function loadVersionFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const version = urlParams.get('version');
    const target = urlParams.get('target');
    const selectElement = document.getElementById('version-select');
    let found = false;

    if (version) {
        selectElement.value = version;
        handleVersionSelection(selectElement);
        selectElement.dispatchEvent(new Event('change'));
    } else {
        Array.from(selectElement.options).reverse().forEach(option => {
            if (found) return;
            if (option.value.includes(target) && !found) {
                option.selected = true;
                handleVersionSelection(selectElement);
                selectElement.dispatchEvent(new Event('change'));
                found = true;
            }
        });
    }
    
}

function createElement(tag, className, innerHTML = '', attributes = {}) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (innerHTML) element.innerHTML = innerHTML;
    Object.keys(attributes).forEach(key => element.setAttribute(key, attributes[key]));
    return element;
}

function updateElementContent(element, content) {
    element.innerHTML = content;
}

function setElementContent(elementsContent) {
    elementsContent.forEach(({ element, content }) => {
        element.innerHTML = content;
    });
}

function createAndAppendOptions(selectElement, models) {

    models.forEach(model => {
        if (model.productDetails.inventory > 0 && window.collectionIsOOS == false) {
            const option = document.createElement("option");
            option.value = model.productDetails.sku;
            option.text = model.productDetails.title;
            selectElement.add(option);
        } else if (window.collectionIsOOS == true ){ 
            const option = document.createElement("option");
            option.value = model.productDetails.sku;
            option.text = model.productDetails.title;
            selectElement.add(option);
        }
    });

}

function appendChildren(parent, ...children) {
    children.forEach(child => parent.appendChild(child));
}


function handleVersionSelection(selectElement) {
    selectElement.addEventListener("change", (e) => {
        const version = e.target.value;
        if (version) {
            const url = new URL(window.location);
            url.searchParams.set('version', version);
            history.pushState({}, '', url);
        }

        Promise.all([
            getContentfulSBBPDP(version),
            getOptionsBySKU(version)
        ]).then(([data, optionsData]) => {
            if (data && data.items && data.items[0] && data.items[0].fields){
                setupPDPInfo(data.items[0].fields, data.items[0].fields.faQs, version, optionsData);
            }
        });
    });
}

function sortOptions(options, orderMap) {
    return Object.entries(options).sort((a, b) => orderMap[a[0]] - orderMap[b[0]]);
}

function getProductVersionBySku(collection, sku) {
    return collection.find(item => item.productDetails.sku === sku);
}

function createThumbnails(images) {
    const thumbnailsContainer = createElement('div', 'thumbnails-container');

    images.forEach((imageSrc, index) => {
        if (imageSrc && (index === 0 || !imageSrc.includes("no-image"))) {

            const thumbnail = createElement('img', 'thumbnail', '', {
                height: "88",
                alt: `Thumbnail ${index + 2}`,
                src: imageSrc
            });
            if (index === 0) thumbnail.classList.add('activeThumb');
            thumbnailsContainer.appendChild(thumbnail);
            preloadImages([imageSrc.replace("88x88", "250x250"), imageSrc.replace("88x88", "500x500")]);
        }
    });

    thumbnailsContainer.addEventListener('click', (event) => {
        const thumbnail = event.target.closest('.thumbnail');
        if (thumbnail) {
            document.querySelector('#version-info-image').src = thumbnail.src;
            thumbnailsContainer.querySelector('.activeThumb')?.classList.remove('activeThumb');
            thumbnail.classList.add('activeThumb');
            document.querySelector('#version-info-image').src = thumbnail.src.replace("88x88", "250x250");
            document.querySelector('#version-info-image').src = thumbnail.src.replace("88x88", "500x500");

        }
    });

    return thumbnailsContainer;
}

function preloadImages(imageArray) {
    for (let i = 0; i < imageArray.length; i++) {
      const img = new Image();
      img.src = imageArray[i];
    }
  }
  

function createModelCard(models) {


    const productVersionContainer = document.getElementById("product-version-container");
    const versionTitle = document.getElementById("version-title");
    const versionSelect = document.getElementById("version-select");
    const versionInfo = document.getElementById("version-info");
    const versionAction = document.getElementById("version-action");
    const versionActionLabel = document.getElementById("version-action-label-text");
    const compLabel = document.getElementById("comp-label-text");

    if (window.collectionIsOOS == true){

        const OOSNotification = createElement("div", "oosNoti flRow hCenter", "", {});
        OOSNotification.innerHTML = `
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 15H11V9H9V15ZM10 7C10.2833 7 10.5208 6.90417 10.7125 6.7125C10.9042 6.52083 11 6.28333 11 6C11 5.71667 10.9042 5.47917 10.7125 5.2875C10.5208 5.09583 10.2833 5 10 5C9.71667 5 9.47917 5.09583 9.2875 5.2875C9.09583 5.47917 9 5.71667 9 6C9 6.28333 9.09583 6.52083 9.2875 6.7125C9.47917 6.90417 9.71667 7 10 7ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z" fill="#0095ff"/>
        </svg>
        <aside class = "flCol" >
            <span class="oosNotiLine">We know you love these servers, so they’ll be back.</span>
            <span class="oosNotiLine">Hit “Request Quote” to get in touch with our sales team.</span>
        </aside>
        `;
        productVersionContainer.insertBefore(OOSNotification, productVersionContainer.firstChild);

    }

    let index = 0;

    if (models[0].productDetails.model === ""){
        index = 1;
    }
    if (window.collectionIsOOS == false){
        setElementContent([
            { element: versionTitle, content: `Select Your ${models[index].productDetails.model} Chassis Version` },
            { element: versionActionLabel, content: `TechMike's Picks: ${models[index].productDetails.model} Configurations` },
            { element: compLabel, content: `Compare ${models[index].productDetails.brandFilter.replaceAll('_', ' ')} ${models[index].productDetails.model} Servers` }
        ]);
    } else {
        setElementContent([
            { element: versionTitle, content: `Explore ${models[index].productDetails.model} Chassis Versions` },
            { element: versionActionLabel, content: `TechMike Also Likes...` },
            { element: compLabel, content: `Compare ${models[index].productDetails.brandFilter.replaceAll('_', ' ')} ${models[index].productDetails.model} Servers` }
        ]);
    }
    createAndAppendOptions(versionSelect, models);
    versionSelect.selectedIndex = 0;

    handleVersionSelection(versionSelect);


}

const optionsCache = new Map();

async function getOptionsBySKU(sku) {
    if (optionsCache.has(sku)) {
        return optionsCache.get(sku);
    }
    try {
        const response = await fetch(`https://apiapi.ombligo.com/setMSP?sku=${sku}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie('csrftoken')  
        }
        });

        if (!response.ok) {
        throw new Error('Network response was not ok');
        }

        const responseData = await response.json();
        optionsCache.set(sku, responseData);
        return responseData;
    } catch (error) {
    //     console.error('There was a problem with the fetch operation:', error);
        return null;
    }
}

    function getCookie(name) {
        let cookieValue = null;
        if (document.cookie && document.cookie !== '') {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
            }
        }
        return cookieValue;
    }

const SBBPDPCache = new Map();

async function getContentfulSBBPDP(sku) {
   if (SBBPDPCache.has(sku)) {
       return SBBPDPCache.get(sku);
   }

   const apiUrl = `https://apiapi.ombligo.com/n_contentful/specific/SBBPDPInfo/sku/${sku}/`;

   try {
       const response = await fetch(apiUrl);
       const data = await response.json();
       SBBPDPCache.set(sku, data);
       return data;
   } catch (error) {
       console.log('Likely No Data:', error);
   }
}

const kvtotag = (key, value) => key + "=" + value;

const createTagQueryString = (product) =>{
    
    let ff_operator = (product.form_factor.includes(3) || product.form_factor.includes(4)) ? " OR " : " AND ";
    
    if (product.title.includes("R830")) {
        ff_operator = " OR ";
    }

    let query = 
        "tag:" + kvtotag("no_cpu", product.noCPU) + " OR " + 
        "tag:" + kvtotag("form_factor", product.form_factor) + ff_operator + 
        "tag:" + kvtotag("cpu_family", product.cpuFamily) + " AND " + 
        "product_type:Server Chassis";
    

    return query;
}


const getSimilarChassis = async (tagQuery) => {

    const domain = 'techmikeny-dev.myshopify.com';
    const storefrontAccessToken = 'c10e82378c6bdb525376d21e11afdc9f';

    const query = `
    {
        products(first: 50, query: "${tagQuery.trim()}") {
            edges {
                node {
                    id
                    title
                    description
                    totalInventory
                    handle
                    variants(first: 1) {
                        edges {
                            node {
                                id
                                title
                                sku
                                price {
                                    amount
                                }
                            }
                        }
                    }
                    images(first: 5) {
                        edges {
                            node {
                                url(transform: {maxWidth: 200})
                                altText
                            }
                        }
                    }
                }
            }
        }
    }
    `;
  
    try {
        const response = await fetch(`https://${domain}/api/2024-07/graphql.json`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
            },
            body: JSON.stringify({ query }),
        });
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('Error fetching product:', error);
        return null;
    }
  };

  function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
}

function createPriceEl(price, type){

    let eppSiteDiscount = sessionStorage.getItem("eppSiteDiscount");
    let el;
    let dc_price;
    if (type === 'mpCard') {
        if (!eppSiteDiscount) {
            el = createElement('div', 'mikes-pick-price', price.toLocaleString('en-US', { style: 'currency', currency: 'USD' }));
        } else {
            dc_price = price * (1 - (eppSiteDiscount / 100)); 
            let fragment = document.createDocumentFragment();

            let dc_price_el = createElement('div', 'mikes-pick-price', dc_price.toLocaleString('en-US', { style: 'currency', currency: 'USD' }));
            let orig = createElement('div', 'mikes-pick-price', price.toLocaleString('en-US', { style: 'currency', currency: 'USD' }));
            
            orig.style.transform = "scale(0.75)";
            orig.style.textDecoration = "line-through";
            dc_price_el.style.bottom = "90px";
            dc_price_el.style.border = '1px solid #0095ff';
            


            fragment.appendChild(orig);
            fragment.appendChild(dc_price_el);

            el = fragment;
        }
    } else if (type === 'actionCard') {
        if (!eppSiteDiscount) {
            el = createElement("div", "version-info-price", price);
        } else {
            let discount = parseFloat(eppSiteDiscount);
            let priceValue = parseFloat(price.replace("$","").replace(",",""));
            
            if (isNaN(discount) || isNaN(priceValue)) {
                throw new Error("Invalid price or discount value");
            }
    
            dc_price = priceValue * (1 - (discount / 100));  

            let fragment = document.createDocumentFragment();

            let dc_price_el = createElement("div", "version-info-price", dc_price.toLocaleString('en-US', { style: 'currency', currency: 'USD' }));
            let orig = createElement("div", "version-info-price", price);
            
            orig.style.textDecoration = 'line-through';
            orig.style.fontSize = "1em";
            
            fragment.appendChild(dc_price_el);
            fragment.appendChild(orig);

            el = fragment;
        }
    }

    return el;
}

async function createMikesPicksCards(level, options, totalPrice, productVersion) {
    const actionContainer = document.getElementById("version-action");

    if (window.collectionIsOOS == true){
        let queryString = createTagQueryString(productDetails);
        let chassis = await getSimilarChassis(queryString);    

        let prods = chassis.products.edges;
        let availableProds = prods.filter(prod => prod.node.totalInventory !== 0);
        //availableProds = availableProds.sort((a, b) => b.node.totalInventory - a.node.totalInventory);
        shuffle(availableProds);
        function addUniqueProduct(p = 0) {

            if (document.querySelectorAll('.mikes-pick-container').length == 3) return;
            if (p >= availableProds.length) {
                console.warn("No unique product found");
                return;
            }
        
            let handle = availableProds[p].node.handle;
            
            if (document.getElementsByClassName(handle).length > 0) {
                addUniqueProduct(p + 1);
                return;
            }
        
            let totalPrice = availableProds[p].node.variants.edges[0].node.price.amount;
            let title = availableProds[p].node.title.replace(" Rack-Mountable", "");
            let mainImage = availableProds[p].node.images.edges[0].node;
                
            const mikesPickContainer = createElement('div', `mikes-pick-container flCol ${handle}`, '', { id: `mikes-pick-container-${p}`, style: "justify-content:unset;" });
            const mikesPickImage = createElement('img', 'tableImg mikes-pick-image', '', {
                height: "275",
                alt: mainImage.altText,
                src: mainImage.url
            });
            const mikesPickTitle = createElement('div', 'mikes-pick-title-related', title);
            const mikesPickPrice = createElement('div', 'mikes-pick-price', parseFloat(totalPrice).toLocaleString('en-US', { style: 'currency', currency: 'USD' }));
            const mikesPickButton = createElement('div', 'mcc-configure-button', `
                <svg class="md-chass-configure-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff">
                    <path d="m620-284 56-56q6-6 6-14t-6-14L540-505q4-11 6-22t2-25q0-57-40.5-97.5T410-690q-17 0-34 4.5T343-673l94 94-56 56-94-94q-8 16-12.5 33t-4.5 34q0 57 40.5 97.5T408-412q13 0 24.5-2t22.5-6l137 136q6 6 14 6t14-6ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
                </svg>Configure`);
        
            mikesPickButton.addEventListener("click", () => {
                window.location.href = `${window.location.origin}/products/${handle}`;
            });
            fetch(`${window.location.origin}/products/${handle}`, {credentials: `include`});
            appendChildren(mikesPickContainer, mikesPickImage, mikesPickTitle, mikesPickPrice, mikesPickButton);
            actionContainer.appendChild(mikesPickContainer);
        }
        
        for (let i = 0; i < 3; i++) {
            addUniqueProduct(i);
        }        

        return
    }

    const orderMap = {
        "processor": 1,
        "ram": 2,
        "storage": 3,
        "raid": 4,
        "dcrd": 5,
        "psu": 6
    };

    const nameMap = {
        "processor": "Processor",
        "ram": "RAM",
        "storage": "Storage",
        "raid": "RAID",
        "dcrd": "NDC",
        "psu": "Power Supply",
        "gpu": "GPU"
    };

    const SVGMap = {
        "Essential": '<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#0095ff"><path d="M160-120v-375l-72 55-48-64 120-92v-124h80v63l240-183 440 336-48 63-72-54v375H160Zm80-80h200v-160h80v160h200v-356L480-739 240-556v356Zm-80-560q0-50 35-85t85-35q17 0 28.5-11.5T320-920h80q0 50-35 85t-85 35q-17 0-28.5 11.5T240-760h-80Zm80 560h480-480Z"/></svg>',
        "Professional": '<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#0095ff"><path d="M480-340q33 0 56.5-23.5T560-420q0-33-23.5-56.5T480-500q-33 0-56.5 23.5T400-420q0 33 23.5 56.5T480-340ZM160-120q-33 0-56.5-23.5T80-200v-440q0-33 23.5-56.5T160-720h160v-80q0-33 23.5-56.5T400-880h160q33 0 56.5 23.5T640-800v80h160q33 0 56.5 23.5T880-640v440q0 33-23.5 56.5T800-120H160Zm0-80h640v-440H160v440Zm240-520h160v-80H400v80ZM160-200v-440 440Z"/></svg>',
        "Enterprise": '<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#0095ff"><path d="M120-120v-560h240v-80l120-120 120 120v240h240v400H120Zm80-80h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm240 320h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm240 480h80v-80h-80v80Zm0-160h80v-80h-80v80Z"/></svg>'
    };

    const mikesPickContainer = createElement('div', 'mikes-pick-container flCol', '', { id: `mikes-pick-container-${level}` });
    const mikesPickTitle = createElement('div', 'mikes-pick-title', `${SVGMap[level]} ${level}`);
    const mikesPickTableContainer = createElement('div', 'mikes-pick-table-container');
    const mikesPickTable = createElement('table', 'mikes-pick-table');

    const mikesPickPrice = createPriceEl(totalPrice, "mpCard");
    const mikesPickButton = createElement('div', 'mcc-configure-button', `
        <svg class="md-chass-configure-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff">
            <path d="m620-284 56-56q6-6 6-14t-6-14L540-505q4-11 6-22t2-25q0-57-40.5-97.5T410-690q-17 0-34 4.5T343-673l94 94-56 56-94-94q-8 16-12.5 33t-4.5 34q0 57 40.5 97.5T408-412q13 0 24.5-2t22.5-6l137 136q6 6 14 6t14-6ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
        </svg>Configure`);

    mikesPickButton.addEventListener("click", () => {
        localStorage.setItem("build", JSON.stringify(options));
        window.location.href = `${window.location.origin}/products/${productVersion.productDetails.handle}/modify`;
    });

    const orderedOptions = sortOptions(options, orderMap);
    const keysWithData = orderedOptions.map(([key]) => key);
    
    Object.keys(nameMap).forEach((key) => {
        const row = mikesPickTable.insertRow();
        const keyCell = row.insertCell(0);
        const valueCell = row.insertCell(1);
        
        row.classList.add('MPRow');
        
        keyCell.innerHTML = `${nameMap[key]}`;
        keyCell.classList.add('MPKeyCell');
        keyCell.style.verticalAlign = 'middle'; 
    
        valueCell.classList.add('MPValueCell');
        
        if (keysWithData.includes(key)) {
            const value = options[key];
            valueCell.innerHTML = `${value.qty}x ${value.title}`;
        } else {
            valueCell.innerHTML = 'None';
        }
    });
    
    appendChildren(mikesPickTableContainer, mikesPickTable);
    appendChildren(mikesPickContainer, mikesPickTitle, mikesPickTableContainer, mikesPickPrice, mikesPickButton);
    actionContainer.appendChild(mikesPickContainer);
}



async function getBlogSnippets(keywords) {

    try {
        const url = new URL('https://apiapi.ombligo.com/getBlogSnippets');
        url.searchParams.append('keywords', keywords);

        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return response.ok ? await response.json() : [];

    } catch (error) {
        console.error('Error fetching blog snippets:', error);
        return [];
    }
}


function createArticleElement(tag, className, innerHTML = '', attributes = {}, children = []) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (innerHTML) element.innerHTML = innerHTML;
    Object.keys(attributes).forEach(key => element.setAttribute(key, attributes[key]));
    children.forEach(child => element.appendChild(child));
    return element;
}

async function createArticleSnippets(model, brand) {
    const container = document.querySelector('#SBBPDPContentResourcesContainer');

    document.querySelector('#SBBPDPContentResourcesContainer').innerHTML = '';
    
    updateElementContent(container, '');

    let keywords = `${model.replace(/PowerEdge|ProLiant/g, '')},${brand},`;

    const snippets = await getBlogSnippets(keywords);
    setTimeout(() => {

        if (snippets.length > 0) {
            container.innerHTML = '';

            snippets.slice(0, 3).forEach(snippetData => {
                const resourceImage = createArticleElement('img', 'resourceImage lazyload', '', {
                    'data-src': `${snippetData.image}?w=159`,  // Deferring image load
                    alt: snippetData.title,
                    'data-srcset': `
                        ${snippetData.image}?w=159 159w,
                        ${snippetData.image}?w=318 318w,
                        ${snippetData.image}?w=300 480w,
                    `,
                    sizes: '(max-width: 159px) 159px, (max-width: 318px) 318px, (max-width: 480px) 480px',
                    width: '159',
                    height: '159',
                });

                const resourceLinkElem = createArticleElement('a', 'resourceLink', '', {
                    href: `/blogs/TechTalk/${snippetData.handle}`,
                    title: snippetData.title,
                });

                appendChildren(resourceLinkElem, 
                    createArticleElement('div', 'resourceImageContainer', '', {}, [resourceImage]),
                    createArticleElement('h3', 'resourceTitle', snippetData.title),
                    createArticleElement('div', 'resourceDescriptionContainer', snippetData.snippet.substring(0, 400) + '...')
                );

                const resourceContainer = createArticleElement('div', 'resourceContainer', '', {}, [resourceLinkElem]);
                container.appendChild(resourceContainer);
            });

            // Lazy load the images when they enter the viewport
            const lazyImages = document.querySelectorAll('.lazyload');
            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const img = entry.target;
                        img.src = img.getAttribute('data-src');
                        img.srcset = img.getAttribute('data-srcset');
                        img.classList.remove('lazyload');
                        observer.unobserve(img);
                    }
                });
            });

            lazyImages.forEach(img => observer.observe(img));

        } else {
            document.querySelector('.mentionedTechTalk').style.opacity = 0;
        }
    }, 100);
}

